export const environment = {
  production: true,
  "apiURL": "https://api-gateway.mycargoservices.net/api/v3/",
  "printURL": "http://localhost:8792/v1/",
  "fulfillmentURL": "https://api-gateway.mycargoservices.net/fulfillment/v1/",
  "storageURL": "https://api-gateway.mycargoservices.net/storage/v1/"
};



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/fulfillment.release/src/environments/environment.ts